<template>
  <div class="flex flex-col gap-16">
    <h2 class="heading-3">{{ title }}</h2>
    <RevCard
      v-if="!showForm && address"
      class="flex items-start justify-between gap-16 p-24"
    >
      <Address :address :with-details with-phone />

      <RevButton
        size="small"
        type="button"
        variant="secondary"
        @click="emit('edit')"
      >
        {{ editButtonTitle }}
      </RevButton>
    </RevCard>

    <slot v-else />
  </div>
</template>

<script lang="ts" setup>
import type { VNode } from 'vue'

import Address from '@backmarket/nuxt-module-address/Address.vue'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'

withDefaults(
  defineProps<{
    title: string
    editButtonTitle: string
    address:
      | ApiSpecs['/bm/cart']['GET']['response']['addressList']['bill']
      | ApiSpecs['/bm/cart']['GET']['response']['addressList']['deliver']
    showForm: boolean
    withDetails?: boolean
  }>(),
  {
    withDetails: true,
  },
)

const emit = defineEmits(['edit'])

defineSlots<{
  default?(): VNode
}>()
</script>
